import {SuccessfulApiResponse} from "@eryxcoop/appyx-comm";

export default class AllRolesResponse extends SuccessfulApiResponse {
    static defaultResponse() {
        return {
            object: {
                'roles': [
                    'FRONTOFFICE_GENERAL_ADMINISTRATOR_ROLE',
                    'FRONTOFFICE_ADMINISTRATIVE_ROLE',
                    'FRONTOFFICE_OPERATIONAL_ROLE'
                ]
            },
            errors: []
        }
    }

    roles() {
        return this.content().roles
    }


}